

















import {
  computePosition, shift, flip, size, Placement,
} from '@floating-ui/dom';
import Vue from 'vue';
import interactable from '../../mixins/interactable/interactable';
import mixins from '../../mixins';

export default mixins(interactable).extend({
  mixins: [interactable],
  props: {
    value: { default: false, type: Boolean },
    fixedSize: { default: false, type: Boolean },
    openOnClick: { default: true, type: Boolean },
    referenceElement: { default: undefined, type: Function },
    canOverlap: { default: false, type: Boolean },
    minWidthOfReference: { default: false, type: Boolean },
    elevation: { default: 3, type: [Number, String] },
    noCloseOnScroll: { default: false, type: Boolean },
    top: { default: false, type: Boolean },
    right: { default: false, type: Boolean },
    bottom: { default: false, type: Boolean },
    left: { default: false, type: Boolean },
    autoStart: { default: false, type: Boolean },
    autoEnd: { default: false, type: Boolean },
  },
  data: () => ({
    noCloseCooldown: false,
    styleList: {
      left: '0',
      top: '0',
      minWidth: undefined,
      maxWidth: undefined,
      maxHeight: undefined,
      minHeight: undefined,
    } as Partial<HTMLElement['style']>,
  }),
  computed: {
    contentClassList(): Record<string, boolean> {
      return {
        'p-menu-content-wrapper': true,
        [`elevation-${this.elevation}`]: true,
        expanded: !!this.value,
      };
    },
  },
  mounted() {
    this.reposition();
    this.$media.addResizeListener(this.onResize);
  },
  beforeDestroy() {
    this.$media.removeResizeListener(this.onResize);
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        if (this.value) {
          this.noCloseCooldown = true;
          setTimeout(() => {
            this.noCloseCooldown = false;
          }, 150);
          this.reposition();
          window.addEventListener('scroll', this.onScroll, true);
        } else {
          window.removeEventListener('scroll', this.onScroll);
        }
      },
    },
  },
  methods: {
    async reposition() {
      const referenceEl = this.$refs.activator as HTMLElement;
      const menuNode = this.$refs.menu as any;
      const menuEl = menuNode.$el as HTMLElement;
      let placement = 'bottom' as Placement;
      if (this.top) {
        placement = 'top';
      }
      if (this.left) {
        placement = 'left-start';
      }
      if (this.right) {
        placement = 'right-start';
      }
      if (this.bottom && this.left) {
        placement = 'bottom-end';
      }
      if (this.bottom && this.right) {
        placement = 'bottom-start';
      }
      if (this.top && this.left) {
        placement = 'top-end';
      }
      if (this.top && this.right) {
        placement = 'top-start';
      }

      const middleware = [];
      const overflowPadding = 40;
      middleware.push(flip({
        padding: overflowPadding,
      }));
      middleware.push(shift({
        padding: overflowPadding,
      }));
      if (!this.fixedSize) {
        middleware.push(size({
          padding: overflowPadding,
          apply: ({ availableWidth, availableHeight, rects }) => {
            const maxWidth = Math.max(availableWidth, window.innerWidth);
            this.styleList.maxWidth = `${maxWidth}px`;
            this.styleList.maxHeight = `${availableHeight}px`;
            if (this.minWidthOfReference) {
              this.styleList.minWidth = `${rects.reference.width}px`;
            }
          },
        }));
      }
      const { x, y } = await computePosition(referenceEl, menuEl, { placement, middleware });
      this.styleList.left = `${x}px`;
      this.styleList.top = `${y}px`;
    },
    onResize() {
      if (this.value) {
        this.reposition();
      }
    },
    onScroll(event: Event) {
      if (this.noCloseOnScroll && this.value) {
        this.reposition();
        return;
      }
      const { target } = event;
      const menu = this.$refs.menu as Vue;
      const menuEl = menu?.$el;
      if (!menuEl || !menuEl.contains(target as Node)) {
        this.closeMenu();
      }
    },
    onClickOutside(event: any) {
      const activator = this.$refs.activator as HTMLElement;
      const isInside = activator.contains(event.target);
      if (!isInside) {
        this.closeMenu();
      }
    },
    closeMenu() {
      if (!this.noCloseCooldown) {
        this.$emit('input', false);
      }
    },
    openMenu() {
      this.$emit('input', true);
    },
    onActivatorClicked() {
      if (this.openOnClick) {
        this.openMenu();
      }
    },
  },
});
